import React, { useMemo } from "react";
import { Sparkles, Star, Plus } from "lucide-react";
import { suggestCategories, ageAt } from "@/lib/categorySuggest";

export const CategorySuggestions = ({ profile, cats, eventDate, rules, principalId, usedIds, onPrincipal, onDobra }) => {
  const list = useMemo(() => suggestCategories(profile, cats, eventDate, rules || []), [profile, cats, eventDate, rules]);
  const hasData = profile.sexo || profile.alturaCm || profile.pesoKg || profile.nascimento;
  const idade = ageAt(profile.nascimento, eventDate);
  if (!hasData) {
    return (
      <div className="text-[11px] text-[var(--text-secondary)]" data-testid="suggest-empty">
        Informe sexo, altura, peso e nascimento para ver as categorias sugeridas.
      </div>
    );
  }
  return (
    <div className="border border-[#C9A84C]/30 bg-[#C9A84C]/5 p-3 space-y-2" data-testid="suggest-box">
      <div className="overline flex items-center gap-1.5">
        <Sparkles size={12} /> Categorias sugeridas
        {idade != null && <span className="text-[var(--text-secondary)] normal-case tracking-normal font-normal">· {idade} anos</span>}
      </div>
      {list.length === 0 && (
        <div className="text-[11px] text-[var(--text-secondary)]" data-testid="suggest-none">
          Nenhuma categoria deste campeonato bate com o perfil informado.
        </div>
      )}
      {list.map(({ cat, motivo, nivel }) => {
        const isPrincipal = cat.id === principalId;
        const used = usedIds.has(cat.id);
        return (
          <div
            key={cat.id}
            data-testid={`suggest-${cat.id}`}
            className="flex items-start gap-2 text-xs px-2 py-1.5 border"
            style={{
              borderColor: nivel === "forte" ? "rgba(201,168,76,0.45)" : "rgba(255,255,255,0.1)",
              background: isPrincipal || used ? "rgba(201,168,76,0.08)" : "transparent",
            }}
          >
            <Star size={12} className="mt-0.5 shrink-0" style={{ color: nivel === "forte" ? "#C9A84C" : "rgba(255,255,255,0.35)" }} />
            <div className="flex-1 min-w-0">
              <div className="font-medium truncate" title={cat.nome}>{cat.nome}</div>
              <div className="text-[10px] text-[var(--text-secondary)]">{motivo}</div>
            </div>
            {isPrincipal ? (
              <span className="text-[9px] tracking-widest text-[#C9A84C] font-bold mt-1">PRINCIPAL</span>
            ) : used ? (
              <span className="text-[9px] tracking-widest text-[#C9A84C] font-bold mt-1">DOBRA</span>
            ) : (
              <div className="flex gap-1 shrink-0">
                <button
                  type="button"
                  className="btn-ghost !py-0.5 !px-1.5 !text-[10px]"
                  onClick={() => onPrincipal(cat.id)}
                  data-testid={`suggest-principal-${cat.id}`}
                  title="Usar como categoria principal"
                >
                  Principal
                </button>
                <button
                  type="button"
                  className="btn-ghost !py-0.5 !px-1.5 !text-[10px] inline-flex items-center gap-0.5"
                  onClick={() => onDobra(cat.id)}
                  data-testid={`suggest-dobra-${cat.id}`}
                  title="Adicionar como dobra"
                >
                  <Plus size={10} /> Dobra
                </button>
              </div>
            )}
          </div>
        );
      })}
      <div className="text-[10px] text-[var(--text-secondary)]">Indicação automática — você decide quais confirmar.</div>
    </div>
  );
};
